import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Icons, Images } from "../../assets/assets";
import PrimaryButton from "../../components/Button/PrimaryButton";
import Modal from "../../components/Modal/Modal";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import Retailers from "../../components/Modal/Retailers/Retailers";
import RetailerModal from "../../components/RetailerModal/RetailerModal";


// const Card: React.FC<CardData> = ({ image, link, content }) => (
//   <div className=" rounded-lg  overflow-hidden">
//     <img src={image} alt={""} className="w-full h-[300px] object-cover m-0" />
//     <div className="pl-4 mt-[-35px]">
//       <p className="box-border text-[rgb(0,34,56)] block  text-sm font-normal leading-normal text-start">
//         {content}
//       </p>
//     </div>
//   </div>
// );

const SpareCylinder = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const clsoeModal = () => {
    setIsModalOpen(false);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Spare CO2 Gas Cylinders | SodaStream SA"}</title>
        <meta
          name="description"
          content={
            "Never run out of bubbles! Buy a spare CO2 gas cylinder for your SodaStream machine and keep the fizz flowing."
          }
        />
        <link
          rel="canonical"
          href={"https://www.sodastream.co.za/spare-cylinders"}
        />
      </Helmet>
      <Modal isOpen={isModalOpen} modalId={""} closeModal={clsoeModal}>
        <div className="text-center px-20 py-20">
          <div className="flex gap-10 ">
            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src={Images.TerraBlack}
                alt="bottles"
                style={{ width: "100%" }}
              />
              <PrimaryButton label="TERRA" />
            </div>

            <div className="items-center justify-center flex flex-col">
              <img
                src={Images.WatterBottleBlack}
                alt="bottles"
                style={{ width: "100%" }}
              />
              <PrimaryButton label="ART" />
            </div>
          </div>
        </div>
      </Modal>

      <Header
        desktopHeight="70vh"
        mobileTextMargin="-51%"

        mobileTitleMargin="12%"
        title="SpareCylinders"
        textBackground="CYLINDERS"
        backgroundImg={
          "http://res.cloudinary.com/brabenjos/image/upload/v1743232017/sodastream/1743232017720.jpg"
        }
      />
      {/*  */}

      <div className="relative z-25 w-full h-[190px]">

        <div className="bg-[#75A7AD] h-auto w-full relative  hidden md:block">
          <div className="h-27"></div>
          <div className="pt-[5%]">
            <div className="bg-[#75A7AD]  h-auto  flex flex-col md:flex-row justify-center items-center pb-3">
              <div className="p-4 m-2 rounded ">
                <img
                  src="https://sodastream.com/cdn/shop/files/icon-healthier_11.png?v=1672146967&width=68"
                  alt=""
                />
              </div>
              <div className="flex flex-row items-center md:items-start">
                <p></p>
                <p className="box-border  text-[rgb(0,34,56)] text-sm font-normal leading-normal">
                  <span className="text-[14px] font-bold rounded-full text-white] hover:bg-[#080A40] focus:outline-none mr-4">
                    Our Pro Tip:
                  </span>{" "}
                  Exchange your empty cylinder for a full one and pay only for
                  the refill. Each cylinder makes up to 15 gallons of fresh
                  sparkling water.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="mt-[-11%] auto bg-white absolute top-[-2rem] left-1/2 transform -translate-x-1/2 
opacity-80 p-8 shadow-lg rounded-lg w-[90%] md:w-1/2">
          <section className="relative w-full  md:z-50 z-9  mb-[20px]">
            <div className="md:relative gap-10  md:z-50 z-9  flex flex-col items-center justify-center w-full">
              <div className="text-[#005D6E]">
                <p
                  className=" text-left text-[20px] md:text-[30px] tracking-normal
          opacity-100 font-bold ">
                  {" "}
                  Spare Cylinders
                </p>

                <p
                  className=" text-[18px]  text-[#002238] cursor-pointer font-normal leading-normal 
            m-0 p-0 text-left ">
                  Keep a backup cylinder and never run out of bubbles. Each
                  cylinder makes up to 15 gallons of fresh sparkling water
                </p>

                {/*  */}

                <section className="flex md:flex-row flex-col gap-4 mt-[20px]">
                  <Link to={"/spare"}>
                    <button
                      className=" md:w-[200px] bg-[#005D6E] text-white w-full max-w-[150px] border-[2px] border-[#75A7AD] h-[40px]
           text-[16px] font-semibold
             rounded-full flex items-center 
             justify-center hover:bg-[#005D6E] hover:text-white focus:outline-none mt-4">
                      BUY ONLINE
                    </button>
                  </Link>
                  <Retailers
                    showModal={showModal}
                    isModalVisible={isModalVisible}
                    setIsModalVisible={setIsModalVisible}
                    buttonClassName="w-full md:w-[150px] bg-white text-[#005D6E] w-full max-w-[150px]
                 border-[2px] border-[#75A7AD] h-[40px]
           text-[16px] font-semibold
             rounded-full flex items-center 
             justify-center  focus:outline-none mt-4 px-4"
                    buttonTitleClassName="text-[14px] leading-[24px] font font-bold 
                      sm:text-[16px] sm:leading-[19px]"
                  />
                </section>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section className="block md:hidden">
        <div className="bg-[#75A7AD]  h-auto  flex flex-col md:flex-row justify-center items-center pb-3">
          <div className="p-4 m-2 rounded ">
            <img
              src="https://sodastream.com/cdn/shop/files/icon-healthier_11.png?v=1672146967&width=68"
              alt=""
            />
          </div>
          <div className="flex flex-row items-center md:items-start">
            <p></p>
            <p className="box-border text-[rgb(0,34,56)] text-sm font-normal leading-normal p-4">
              <span className="text-[14px] font-bold rounded-full text-[#080A40] hover:bg-[#080A40] focus:outline-none mr-4">
                Our Pro Tip:
              </span>{" "}
              Exchange your empty cylinder for a full one and pay only for the
              refill. Each cylinder makes up to 15 gallons of fresh sparkling
              water.
            </p>
          </div>
        </div>
      </section>
      {/*  */}
      <section className="bg-[#efebe4]">
        {/* refill now */}

        <div>
          <h1 className="box-border text-center text-[rgb(0,34,56)] block text-2xl font-semibold h-[38px] leading-[38.4px] mb-1  pt-[75px]">
            Getting a refill or a back up?
          </h1>
          <p className="box-border pt-[30px] text-center text-[rgb(0,34,56)] block text-[16px] font-normal leading-[30.72px]">
            Find the best option for you
          </p>
        </div>

        <section className="flex flex-col md:flex-row  space-y-4 md:space-y-0 md:space-x-4">
          <div className=" text-white p-4 flex-1">
            {/*  */}

            {/*  */}
            <section className="">
              <div className="flex flex-wrap">
                <div className=" text-white p-4 flex-1 w-[50%] hidden md:block">
                  {/* Contenu du premier élément */}
                </div>
                <div className=" text-white  flex-1 w-[100%] md:w-[50%]">
                  <div className=" rounded-lg overflow-hidden">
                    <div className="w-full ">
                      <img
                        src={Images.ExchangeBottleSpareImg}
                        alt="order spare"
                        className="w-full h-[180px] object-cover rounded-[10px]"
                      />
                    </div>
                    <div className="pl-4 mt-3">
                      <h1
                        className="box-border text-left text-[rgb(0,34,56)] text-[18px]
    block  text-2xl font-semibold h-auto leading-[38.4px]">
                        Exchange Empty Cylinders
                      </h1>
                      <h2
                        className="text-[16px] box-border text-[rgb(0,34,56)] block  text-sm font-normal 
   leading-normal 
   
     text-start">
                        {
                          "Return your empty cylinders for full ones and pay only for the refill"
                        }
                      </h2>
                      <div className="mt-4">
                      <RetailerModal buttonText="Refill Now"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="bg-[] text-white p-4 flex-1">
            <section
              className="flex flex-col md:flex-row  
            space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-wrap">
                <div className="text-white  flex-1 w-[100%] md:w-[50%]">
                  <div className="rounded-lg overflow-hidden">
                    <img
                      src={
                        "http://res.cloudinary.com/brabenjos/image/upload/v1723698373/sodastream/1723698373210.webp"
                      }
                      alt={""}
                      className="w-full h-auto object-cover rounded-[10px]"
                    />
                    <div className="pl-4">
                      <h1
                        className="box-border text-left text-[rgb(0,34,56)] text-[18px]
    block  text-2xl font-semibold h-auto leading-[38.4px] mb-1  
    pt-[9px]">
                        Order a Spare
                      </h1>
                      <h2
                        className=" text-[16px] box-border text-[rgb(0,34,56)] block  text-sm 
   font-normal leading-normal 
     text-start">
                        {"Buy a spare cylinder online and never run out of gas"}
                      </h2>
                      <Link to="/spare">
                        <button
                          className="bg-white border border-[#005D6E] text=[#005D6E] rounded-[46px] flex items-center justify-center cursor-pointer px-4 h-[30px] mt-[390px]">
                          Buy a spare
                        </button>
                      </Link>
                     
                    </div>
                  </div>
                </div>
                <div className=" text-white p-4 flex-1 w-[50%] hidden md:block"></div>
              </div>
            </section>
          </div>
        </section>
      </section>

      <section>
        <div className="flex justify-between md:px-60 px-10 py-10 gap-10 text-[#005D6E]">
          <div className="">
            <img
              src={Images.CylindersWithRippleImg}
              alt="cylinder with ripple"
            />
          </div>
          <div className="flex flex-col gap-4 items-start justify-center text-start">
            <h2
              className=" box-border text-left text-[18px]
    block  text-2xl font-semibold h-auto leading-[38.4px] mb-1  
    pt-[9px]">
              Any empty cylinders lying around?
            </h2>
            <p
              className=" text-[16px] box-border  block  text-sm 
   font-normal leading-normal 
     text-start">
              Don’t forget to send them back! Replacing empty cylinders with
              full ones saves you money and helps the environment.
            </p>
            <div>
              <Link to="/store-locator">
                <button
                  className="bg-[#005D6E] text-white w-full max-w-[150px] border-[2px] border-[#75A7AD] h-[35px]
           text-[16px] font-semibold
             rounded-full flex items-center 
             justify-center hover:bg-[#005D6E] hover:text-white focus:outline-none mt-4 px-4">
                  Retailers
                </button>
                {/* <SecondaryButton label="REFILL NOW" /> */}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section>
          <div className="relative h-auto md:h-[400px] w-full bg-[#EEEAE5] p-20 md:px-40 px-10 flex flex-col-reverse md:flex-row justify-between items-center">
            <div className="md:basis-[50%] basis-[100%]">
              <div className="flex flex-col gap-4 items-start justify-center text-start md:w-2/3">
                <div className="basis-[50%] py-20 text-start flex flex-col gap-5">
                  <h2
                    className="text-[20px]  box-border text-[rgb(0,93,110)] block text-2xl font-semibold 
      leading-[38.4px] text-start">
                    Our gas cylinders
                  </h2>
                  <p
                    className="box-border text-sm font-normal leading-normal
     text-start">
                    Each sparkling water maker is compatible with a specific
                    cylinder: either the Classic screw-in system or the Quick
                    Connect system.
                  </p>
                </div>
              </div>
            </div>

            <div className="md:basis-[40%] basis-[100%] ">
              <img
                src={Images.CylinderUS}
                alt="cylunder img"
                className=" bottom-0 left-0 z-50"
                style={{ width: "70%" }}
              />
            </div>
          </div>
        </section>
        

      <section>
        <div className="text-[#005D6E] flex flex-col gap-10 items-center justify-center px-5 py-5 md:px-20 md:py-20 pb-40">
          <h2 className="text-[20px] font-bold">SodaStream benefits</h2>
          <div className="md:flex md:flex-nowrap flex-wrap gap-5 grid grid-cols-2 md:gap-0 justify-between items-center">
            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src={Icons.IconSparklingSmall}
                alt="sparkling water"
                style={{ width: "40%" }}
              />
              <span className="font-bold text-[14px]">SUSTAINABLE SPARKLE</span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src={Icons.IconQuickyEasy}
                alt="sparkling water"
                style={{ width: "40%" }}
              />
              <span className="font-bold text-[14px]">QUICK & EASY</span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src={Icons.IconQualityFirst}
                alt="sparkling water"
                style={{ width: "40%" }}
              />
              <span className="font-bold text-[14px]">QUALITY FIRST</span>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src={Icons.IconFreshCertified}
                alt="sparkling water"
                style={{ width: "40%" }}
              />
              <span className="font-bold text-[14px]">FRESH & CERTIFIED</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SpareCylinder;
